'use strict';

require('../shared/base-entry');
require('./views/merchant-main');
require('./views/merchant-ppc');
require('../shared/post-entry');
